// extracted by mini-css-extract-plugin
export default {"notification":"vmIa7A","closed":"FlxivV","notificationWithAnimation":"ypi1u5","openNotification":"vyvdPp","closeButton":"EGi6a_"};